import { QUALITYFER_VIABILITY_RESET } from "../constants";

export const qualityferViabilityResetRedux = () => async (dispatch: any) => {
    dispatch({ type: QUALITYFER_VIABILITY_RESET });
};